export default {
  // Nav
  nav: {
    bracket: '赛程表',
    leaderboard: '排行榜',
    champion: '冠军预测',
    championBoard: '冠军榜',
    admin: '管理',
    myPick: '我的预测',
    signOut: '退出登录',
    signOutConfirm: '确认退出？',
    yes: '是',
    no: '否',
  },

  // Join / Auth
  join: {
    title: '2026世界杯预测',
    subtitle: 'FIFA世界杯淘汰赛预测挑战',
    enterCode: '输入邀请码',
    enterCodeDesc: '你需要邀请码才能加入，请向你的小组管理员索取。',
    inviteCode: '邀请码',
    inviteCodePlaceholder: '请输入邀请码',
    verifyCode: '验证邀请码',
    signIn: '登录',
    createAccount: '创建账号',
    displayName: '显示名称',
    displayNamePlaceholder: '例如：小明',
    email: '邮箱',
    emailOptional: '（选填 — 用于找回密码）',
    emailPlaceholder: 'you@example.com',
    password: '密码',
    passwordPlaceholder: '至少8位字符',
    passwordSignInPlaceholder: '请输入密码',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '再次输入密码',
    forgotPassword: '忘记密码？',
    differentCode: '← 使用其他邀请码',
    nameHint: '2–30个字符，必须唯一',
    welcome: '欢迎，{{name}}！',
    passwordMismatch: '两次密码不一致',
    passwordTooShort: '密码至少需要8位字符',
    group: '小组',
    invalidCode: '邀请码无效或已过期。',
  },

  // Forgot / Reset password
  forgotPassword: {
    title: '重置密码',
    heading: '忘记密码了？',
    desc: '输入注册时使用的邮箱，我们将发送重置链接给你。',
    emailLabel: '邮箱地址',
    send: '发送重置链接',
    sentTitle: '请查收邮件',
    sentDesc: '如果该邮箱已注册，重置链接已发送。如果你没有设置邮箱，请联系管理员手动重置。',
    backToSignIn: '返回登录',
  },
  resetPassword: {
    title: '设置新密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    submit: '设置新密码',
    successTitle: '密码已更新！',
    successDesc: '正在跳转到登录页面…',
    invalidLink: '重置链接无效。',
    requestNew: '重新申请。',
    mismatch: '两次密码不一致',
    tooShort: '密码至少需要8位字符',
  },

  // Bracket
  bracket: {
    title: '2026世界杯预测',
    subtitle: '淘汰赛赛程',
    preliminaryBadge: '预测赛程',
    confirmedBadge: '赛程已确认',
    lockIn: '预测将在以下时间锁定',
    nextLockIn: '下一场比赛将在以下时间锁定',
    open: '预测开放中',
    locked: '🔒 已锁定',
    scorePredictions: '预测比分（+3分奖励）',
    picked: '已选 {{count}}/{{total}}',
    save: '保存预测',
    notAvailable: '赛程尚未公布',
    notAvailableDesc: '小组赛结束后，管理员将设置淘汰赛赛程。',
    thirdPlace: '季军赛',
    savedCount: '已保存 {{count}} 条预测！',
    preliminary: '~ 暂定',
    pickNow: '● 正在预测',
    matchupsReady: '⚡ 对阵已出',
    rounds: {
      R32: '32强赛',
      R16: '16强赛',
      QF: '四分之一决赛',
      SF: '半决赛',
      '3RD': '季军赛',
      FINAL: '决赛',
    },
  },

  // Leaderboard
  leaderboard: {
    title: '排行榜',
    updated: '更新于 {{time}}',
    loading: '加载中…',
    global: '🌍 全球',
    yourPosition: '你的排名',
    maxPts: '/ 最高 {{max}} 分',
    players: '参与人数',
    leaderPts: '领先分数',
    aiPlayers: 'AI选手',
    noPicksYet: '还没有预测，成为第一个吧！',
    championBoard: '🎯 冠军榜',
    submitted: '已提交',
    picksTitle: '赛程预测',
    picksLocked: '本轮锁定后才能查看其他人的预测。',
  },

  // Champion Pick
  champion: {
    title: '冠军预测',
    subtitle: '谁会赢得世界杯？',
    board: '🎯 冠军榜',
    infoTitle: '仅预测冠军模式',
    infoDesc: '预测冠军得主，猜对可获得 <b>20分</b>。你也可以填写完整赛程预测以获得更多分数。',
    infoDescPre: '预测冠军得主，猜对可获得',
    infoDescPost: '。你也可以填写完整赛程预测以获得更多分数。',
    points: '分',
    locked: '预测已锁定。',
    currentPick: '你当前的预测',
    search: '搜索球队…',
    group: '{{name}}组',
    pickBtn: '选择 {{flag}} {{name}}',
    selectTeam: '请选择球队',
    saved: '冠军预测已保存！',
  },

  // Champion Board
  championBoard: {
    title: '冠军榜',
    subtitle: '谁猜中了冠军？',
    myPick: '我的预测',
    pending: '决赛结束后揭晓冠军。',
    worldChampion: '世界杯冠军',
    correctOf: '{{total}}位预测者中有{{count}}位猜对了',
    yourPick: '你的预测',
    totalPicks: '总预测数',
    teamsPicked: '已选球队数',
    correct: '猜中人数',
    noPicks: '还没有冠军预测，成为第一个吧！',
    pickChampion: '预测冠军',
    champion: '冠军 ✓',
    picked: '{{count}}人选择',
  },

  // Group Standings
  standings: {
    title: '小组赛',
    subtitle: '实时积分榜 · 每60秒自动刷新',
    group: '{{name}}组',
    pos: '排名',
    team: '球队',
    p: '场',
    w: '胜',
    d: '平',
    l: '负',
    gf: '进球',
    ga: '失球',
    gd: '净胜球',
    pts: '积分',
    noData: '积分榜暂不可用。',
    noDataDesc: '小组赛开始后将会显示。',
    qualifies: '晋级',
    thirdPlayoff: '最佳第三',
    fetchedAt: '更新于 {{time}}',
    nav: '积分榜',
  },

  // Misc
  common: {
    back: '← 返回',
    error: '错误',
    failedToLoad: '加载失败',
  },

  // Feature strip
  features: {
    exactScore: '精确比分',
    exactScoreDesc: '+3分奖励',
    progressive: '累进积分',
    progressiveDesc: '32强→决赛 1→16分',
    championPick: '冠军预测',
    championPickDesc: '提前预测 +20分',
  },
} as const
